// Test.jsx
import React, { useState } from "react";
// import axios from 'axios';
import { useRecoilState } from "recoil";
// import tripState from '../../components/atoms/Trip.atom';
import plane from "../../images/Shape.png";
import bag from "../../images/luggage-round-24px.png";
import address from "../../images/pin-drop-twotone-24px.be943d97.png";
import { IoMdArrowDropdown } from "react-icons/io";
import airportState from "../../components/atoms/Airport.atom";
import travelState from "../../components/atoms/Travel.atom";
import destinationState from "../../components/atoms/Destination.atom";
import typeState from "../../components/atoms/Type.atom";
import priceState from "../../components/atoms/Price.atom";
import fromState from "../../components/atoms/From.atom";
import toState from "../../components/atoms/To.atom";
import goDateState from "../../components/atoms/goDate.atom";
import backDateState from "../../components/atoms/backDate.atom";
import { Link } from "react-router-dom";

const Test = () => {
  const [show, setShow] = useState(true);
  const [data, setData] = useState(true);
  const [type, setType] = useState(true);
  const [city, setCity] = useState(false);
  const [city2, setCity2] = useState(false);
  const [city3, setCity3] = useState(false);
  const [air, setAir] = useState(false);
  const [inp, setInp] = useState(true);
  const [travel, setTravel] = useRecoilState(travelState);
  const [destinaton, setDestination] = useRecoilState(destinationState);
  const [airport, setAirport] = useRecoilState(airportState);
  const [tripe, setTrip] = useRecoilState(typeState);
  const [money, setMoney] = useRecoilState(priceState);
  const [from, setFrom] = useRecoilState(fromState);
  const [to, setTo] = useRecoilState(toState);
  const [goDate, setGoDate] = useRecoilState(goDateState);
  const [backDate, setBackDate] = useRecoilState(backDateState);
  const today = new Date().toISOString().split("T")[0];

  localStorage.setItem("pickup", travel);
  localStorage.setItem("arrival", destinaton);
  localStorage.setItem("type", tripe);
  localStorage.setItem("price", money);
  localStorage.setItem("pickupInp", from);
  localStorage.setItem("arrivalInp", to);
  localStorage.setItem("pickupDate", goDate);
  localStorage.setItem("returnDate", backDate);

  function TripPrice({ travel, destination, type, price }) {
    if (
      (travel === "Cairo" || travel === "Alex") &&
      (destination !== "Address" || destination !== "") &&
      from !== "" &&
      to !== "" &&
      goDate !== today
    ) {
      return (
        <p className="mt-4 price mb-0">
          {type} trip price starts from <br />
          <span>{price}</span>
        </p>
      );
    }
  }

  function AirportPrice({ travel, destination, type, price }) {
    if (
      (travel === "Cairo International Airport" ||
        travel === "Borg El Arab International Airport" ||
        travel === "Sphinx Airport") &&
      (destination === "Alex" || destination === "Cairo") &&
      from !== "" &&
      to !== ""
    ) {
      return (
        <p className="mt-4 price mb-0">
          {type} trip price starts from <br />
          <span>{price}</span>
        </p>
      );
    }
  }

  function AirportGo({ travel, destination, type, price }) {
    if (
      (destination === "Cairo International Airport" ||
        destination === "Borg El Arab International Airport" ||
        destination === "Sphinx Airport") &&
      (travel === "Alex" || travel === "Cairo") &&
      from !== "" &&
      to !== ""
    ) {
      return (
        <p className="mt-4 price mb-0">
          {type} trip price starts from <br />
          <span>{price}</span>
        </p>
      );
    }
  }

  function Price({ travel, destination, type }) {
    if (travel !== "" && destination !== "" && type === "One Way") {
      return (
        <>
          <p className="m-0">500</p>
          {setMoney(500)}
        </>
      );
    } else if (travel !== "" && destination !== "" && type === "Round") {
      return (
        <>
          <p className="m-0">1000</p>
          {setMoney(1000)}
        </>
      );
    }
  }
  function PriceAir({ travel, destination, type }) {
    if (travel !== "" && destination !== "" && type === "One Way") {
      return (
        <>
          <p className="m-0">1000</p>
          {setMoney(1000)}
        </>
      );
    } else if (travel !== "" && destination !== "" && type === "Round") {
      return (
        <>
          <p className="m-0">2000</p>
          {setMoney(2000)}
        </>
      );
    }
  }

  function PriceGo({ travel, destination, type }) {
    if (travel !== "" && destination !== "" && type === "One Way") {
      return (
        <>
          <p className="m-0">1000</p>
          {setMoney(1000)}
        </>
      );
    } else if (travel !== "" && destination !== "" && type === "Round") {
      return (
        <>
          <p className="m-0">2000</p>
          {setMoney(2000)}
        </>
      );
    }
  }

  function Detail({ from, to }) {
    if (from !== "" && to !== "") {
      return (
        <Link to={"/details"}>
          <button type="button" className="btn mt-4">
            Search
          </button>
        </Link>
      );
    } else {
      return (
        <button type="submit" className="btn mt-4">
          Search
        </button>
      );
    }
  }

  // const [trips, setTrips] = useRecoilState(tripState);
  // const [newTrip, setNewTrip] = useState({
  //   type: 'one-way',
  //   startLocation: '',
  //   endLocation: '',
  //   packup: '',
  //   return:''
  // });

  // const handleChange = (e) => {
  //   setNewTrip({
  //     ...newTrip,
  //     [e.target.name]: e.target.value
  //   });
  // };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   try {
  //     const response = await axios.post('http://localhost:5000/trips', newTrip);
  //     console.log(response.data);
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  //    const handleDelete = async (id) => {
  //     try {
  //       await axios.delete(`http://127.0.0.1:5000/trips/${id}`);
  //       setTrips(trips.filter(trip => trip._id !== id));
  //     } catch (error) {
  //       console.error('Error deleting trip:', error);
  //     }
  //   };

  //  useEffect(() => {
  //     const fetchTrips = async () => {
  //       try {
  //         const response = await axios.get('http://127.0.0.1:5000/trips');
  //         setTrips(response.data);
  //       } catch (error) {
  //         console.error('Error fetching trips:', error);
  //       }
  //     };
  //     fetchTrips();
  //   }, [setTrips]);

  return (
    <div className="parent">
      <ul className="d-flex flex-wrap justify-content-around p-0">
        <li
          className={show ? "text-center active" : "text-center "}
          onClick={() => {
            setShow(true);
            setType(true);
          }}>
          <img src={plane} alt="plane" />
          <p className="mt-2">Airport Limo</p>
        </li>
        <li
          className={show ? "text-center " : "text-center active "}
          onClick={() => {
            setShow(false);
            setType(false);
          }}>
          <img src={bag} alt="bag" />
          <p className="mt-2">Travel Limo</p>
        </li>
      </ul>
      {type ? (
        <>
          <h2>Book Airport Limo</h2>
          <form
            onSubmit={(e) => {
              e.preventDefault();
            }}
            className=" position-relative">
            <div
              className="swap"
              onClick={() => {
                setInp(!inp);
              }}></div>
            <div className="d-flex justify-content-end gap-4">
              <label className="trip d-flex justify-content-center align-items-center">
                <input
                  className="me-2"
                  onClick={() => {
                    setData(true);
                    setTrip("One Way");
                  }}
                  type="radio"
                  name="type"
                  value="one-way"
                />
                <span className="custom-radio"></span>
                One Way
              </label>
              <label className="trip d-flex justify-content-center align-items-center">
                <input
                  className="me-2 "
                  onClick={() => {
                    setData(false);
                    setTrip("Round");
                  }}
                  type="radio"
                  name="type"
                  value="round-trip"
                />
                <span className="custom-radio"></span>
                Round Trip
              </label>
            </div>
            {data ? (
              <>
                <label className="info" htmlFor="startLocation">
                  Pickup From
                </label>
                <br />
                {inp ? (
                  <div
                    className={
                      air
                        ? "input-group mb-3 position-relative active"
                        : "input-group mb-3 position-relative"
                    }>
                    <span className="input-group-text extra" id="basic-addon1">
                      <img className="address" src={address} alt="address" />{" "}
                      Airport
                    </span>
                    <input
                      className="form-control pointer"
                      name="startLocation"
                      placeholder="start Location"
                      onClick={(e) => {
                        setAir(!air);
                      }}
                      value={airport}
                    />
                    <IoMdArrowDropdown className="down" />
                    <ul className="port">
                      <li className="disabled">Cairo</li>
                      <li
                        onClick={() => {
                          setAir(!air);
                          setAirport("Cairo International Airport");
                          setFrom("Cairo International Airport");
                          setTravel("Cairo");
                        }}>
                        Cairo International Airport
                      </li>
                      <li className="disabled">Alex</li>
                      <li
                        onClick={() => {
                          setAir(!air);
                          setAirport("Borg El Arab International Airport");
                          setFrom("Borg El Arab International Airport");
                          setTravel("Alex");
                        }}>
                        Borg ElArab International Airport
                      </li>
                      <li className="disabled">Sphinx</li>
                      <li
                        onClick={() => {
                          setAir(!air);
                          setAirport("Sphinx Airport");
                          setFrom("Sphinx Airport");
                          setTravel("Sphinx");
                        }}>
                        Sphinx Airport
                      </li>
                    </ul>
                  </div>
                ) : (
                  <div className="input-group mb-3 position-relative">
                    <span
                      className={
                        city3
                          ? "input-group-text extra active"
                          : "input-group-text extra"
                      }
                      id="basic-addon1"
                      onClick={() => {
                        setCity3(!city3);
                      }}>
                      <img className="address" src={address} alt="address" />{" "}
                      {travel}
                      <IoMdArrowDropdown className="down" />
                      <ul className="ul">
                        <li
                          onClick={() => {
                            setTravel("Cairo");
                          }}>
                          Cairo
                        </li>
                        <li
                          onClick={() => {
                            setTravel("Alex");
                          }}>
                          Alex
                        </li>
                      </ul>
                    </span>
                    <input
                      className="form-control"
                      name="startLocation"
                      placeholder="start Location"
                      onChange={(e) => {
                        setFrom(e.target.value);
                      }}
                    />
                  </div>
                )}

                <label className="info" htmlFor="endLocation">
                  Arival To
                </label>
                <br />
                {inp ? (
                  <div className="input-group mb-3 position-relative">
                    <span
                      className={
                        city3
                          ? "input-group-text extra active"
                          : "input-group-text extra"
                      }
                      id="basic-addon1"
                      onClick={() => {
                        setCity3(!city3);
                      }}>
                      <img className="address" src={address} alt="address" />{" "}
                      {destinaton}
                      <IoMdArrowDropdown className="down" />
                      <ul className="ul">
                        <li
                          onClick={() => {
                            setDestination("Cairo");
                          }}>
                          Cairo
                        </li>
                        <li
                          onClick={() => {
                            setDestination("Alex");
                          }}>
                          Alex
                        </li>
                      </ul>
                    </span>
                    <input
                      className="form-control"
                      name="endLocation"
                      placeholder="End Location"
                      onChange={(e) => {
                        setTo(e.target.value);
                      }}
                    />
                  </div>
                ) : (
                  <div
                    className={
                      air
                        ? "input-group mb-3 position-relative active"
                        : "input-group mb-3 position-relative"
                    }>
                    <span className="input-group-text extra" id="basic-addon1">
                      <img className="address" src={address} alt="address" />{" "}
                      Airport
                    </span>
                    <input
                      className="form-control pointer"
                      name="endLocation"
                      placeholder="end Location"
                      onClick={() => {
                        setAir(!air);
                      }}
                      value={airport}
                    />
                    <IoMdArrowDropdown className="down" />
                    <ul className="port">
                      <li className="disabled">Cairo</li>
                      <li
                        onClick={() => {
                          setAir(!air);
                          setAirport("Cairo International Airport");
                          setTo("Cairo International Airport");
                          setDestination("Cairo");
                        }}>
                        Cairo International Airport
                      </li>
                      <li className="disabled">Alex</li>
                      <li
                        onClick={() => {
                          setAir(!air);
                          setAirport("Borg El Arab International Airport");
                          setTo("Borg El Arab International Airport");
                          setDestination("Alex");
                        }}>
                        Borg ElArab International Airport
                      </li>
                      <li className="disabled">Sphinx</li>
                      <li
                        onClick={() => {
                          setAir(!air);
                          setAirport("Sphinx Airport");
                          setTo("Sphinx Airport");
                          setDestination("Sphinx");
                        }}>
                        Sphinx Airport
                      </li>
                    </ul>
                  </div>
                )}
                <label className="info mt-4" htmlFor="packup">
                  Packup Date{" "}
                </label>
                <br />
                <input
                  className="form-control date"
                  name="packup"
                  type="date"
                  defaultValue={today}
                  onChange={(e) => {
                    setGoDate(e.target.value);
                  }}
                />
                <div className="button d-flex justify-content-between">
                  <AirportPrice
                    travel={from}
                    destination={destinaton}
                    type={tripe}
                    price={
                      <PriceAir
                        travel={from}
                        destination={destinaton}
                        type={tripe}
                      />
                    }
                  />
                  <AirportGo
                    travel={travel}
                    destination={to}
                    type={tripe}
                    price={
                      <PriceGo travel={travel} destination={to} type={tripe} />
                    }
                  />
                  <Detail from={from} to={to} />
                </div>
              </>
            ) : (
              <>
                <label className="info" htmlFor="startLocation">
                  Pickup From
                </label>
                <br />
                {inp ? (
                  <div
                    className={
                      air
                        ? "input-group mb-3 position-relative active"
                        : "input-group mb-3 position-relative"
                    }>
                    <span className="input-group-text extra" id="basic-addon1">
                      <img className="address" src={address} alt="address" />{" "}
                      Airport
                    </span>
                    <input
                      className="form-control pointer"
                      name="startLocation"
                      placeholder="start Location"
                      onClick={() => {
                        setAir(!air);
                      }}
                      value={airport}
                    />
                    <IoMdArrowDropdown className="down" />
                    <ul className="port">
                      <li className="disabled">Cairo</li>
                      <li
                        onClick={() => {
                          setAir(!air);
                          setAirport("Cairo International Airport");
                          setFrom("Cairo International Airport");
                          setTravel("Cairo");
                        }}>
                        Cairo International Airport
                      </li>
                      <li className="disabled">Alex</li>
                      <li
                        onClick={() => {
                          setAir(!air);
                          setAirport("Borg El Arab International Airport");
                          setFrom("Borg El Arab International Airport");
                          setTravel("Alex");
                        }}>
                        Borg ElArab International Airport
                      </li>
                      <li className="disabled">Sphinx</li>
                      <li
                        onClick={() => {
                          setAir(!air);
                          setAirport("Sphinx Airport");
                          setFrom("Sphinx Airport");
                          setTravel("Sphinx");
                        }}>
                        Sphinx Airport
                      </li>
                    </ul>
                  </div>
                ) : (
                  <div className="input-group mb-3 position-relative">
                    <span
                      className={
                        city3
                          ? "input-group-text extra active"
                          : "input-group-text extra"
                      }
                      id="basic-addon1"
                      onClick={() => {
                        setCity3(!city3);
                      }}>
                      <img className="address" src={address} alt="address" />{" "}
                      {travel}
                      <IoMdArrowDropdown className="down" />
                      <ul className="ul">
                        <li
                          onClick={() => {
                            setTravel("Cairo");
                          }}>
                          Cairo
                        </li>
                        <li
                          onClick={() => {
                            setTravel("Alex");
                          }}>
                          Alex
                        </li>
                      </ul>
                    </span>
                    <input
                      className="form-control"
                      name="startLocation"
                      placeholder="start Location"
                      onChange={(e) => {
                        setFrom(e.target.value);
                      }}
                    />
                  </div>
                )}

                <label className="info" htmlFor="endLocation">
                  Arival To
                </label>
                <br />
                {inp ? (
                  <div className="input-group mb-3 position-relative">
                    <span
                      className={
                        city3
                          ? "input-group-text extra active"
                          : "input-group-text extra"
                      }
                      id="basic-addon1"
                      onClick={() => {
                        setCity3(!city3);
                      }}>
                      <img className="address" src={address} alt="address" />{" "}
                      {destinaton}
                      <IoMdArrowDropdown className="down" />
                      <ul className="ul">
                        <li
                          onClick={() => {
                            setDestination("Cairo");
                          }}>
                          Cairo
                        </li>
                        <li
                          onClick={() => {
                            setDestination("Alex");
                          }}>
                          Alex
                        </li>
                      </ul>
                    </span>
                    <input
                      className="form-control"
                      name="endLocation"
                      placeholder="End Location"
                      onChange={(e) => {
                        setTo(e.target.value);
                      }}
                    />
                  </div>
                ) : (
                  <div
                    className={
                      air
                        ? "input-group mb-3 position-relative active"
                        : "input-group mb-3 position-relative"
                    }>
                    <span className="input-group-text extra" id="basic-addon1">
                      <img className="address" src={address} alt="address" />{" "}
                      Airport
                    </span>
                    <input
                      className="form-control pointer"
                      name="endLocation"
                      placeholder="end Location"
                      onClick={() => {
                        setAir(!air);
                      }}
                      value={airport}
                    />
                    <IoMdArrowDropdown className="down" />
                    <ul className="port">
                      <li className="disabled">Cairo</li>
                      <li
                        onClick={() => {
                          setAir(!air);
                          setAirport("Cairo International Airport");
                          setTo("Cairo International Airport");
                          setDestination("Cairo");
                        }}>
                        Cairo International Airport
                      </li>
                      <li className="disabled">Alex</li>
                      <li
                        onClick={() => {
                          setAir(!air);
                          setAirport("Borg El Arab International Airport");
                          setTo("Borg El Arab International Airport");
                          setDestination("Alex");
                        }}>
                        Borg ElArab International Airport
                      </li>
                      <li className="disabled">Sphinx</li>
                      <li
                        onClick={() => {
                          setAir(!air);
                          setAirport("Sphinx Airport");
                          setTo("Sphinx Airport");
                          setDestination("Sphinx");
                        }}>
                        Sphinx Airport
                      </li>
                    </ul>
                  </div>
                )}
                <div className="d-flex justify-content-between">
                  <div className="packup">
                    <label className="info mt-4" htmlFor="packup">
                      Packup Date{" "}
                    </label>
                    <br />
                    <input
                      className="form-control date"
                      name="packup"
                      type="date"
                      defaultValue={today}
                      onChange={(e) => {
                        setGoDate(e.target.value);
                      }}
                    />
                  </div>
                  <div className="return">
                    <label className="info mt-4" htmlFor="return">
                      Return Date{" "}
                    </label>
                    <br />
                    <input
                      className="form-control date"
                      name="return"
                      type="date"
                      defaultValue={today}
                      onChange={(e) => {
                        setBackDate(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="button d-flex justify-content-between">
                  <AirportPrice
                    travel={from}
                    destination={destinaton}
                    type={tripe}
                    price={
                      <PriceAir
                        travel={from}
                        destination={destinaton}
                        type={tripe}
                      />
                    }
                  />
                  <AirportGo
                    travel={travel}
                    destination={to}
                    type={tripe}
                    price={
                      <PriceGo travel={travel} destination={to} type={tripe} />
                    }
                  />
                  <Detail from={from} to={to} />
                </div>
              </>
            )}
          </form>
        </>
      ) : (
        <>
          <h2>Book Travel Limo</h2>
          <form>
            <div className="d-flex justify-content-end gap-4">
              <label className="trip d-flex justify-content-center align-items-center">
                <input
                  className="me-2"
                  onClick={() => {
                    setData(true);
                    setTrip("One Way");
                  }}
                  type="radio"
                  name="type"
                  value="one-way"
                />
                <span className="custom-radio"></span>
                One Way
              </label>
              <label className="trip d-flex justify-content-center align-items-center">
                <input
                  className="me-2 "
                  onClick={() => {
                    setData(false);
                    setTrip("Round");
                  }}
                  type="radio"
                  name="type"
                  value="round-trip"
                />
                <span className="custom-radio"></span>
                Round Trip
              </label>
            </div>
            {data ? (
              <>
                <label className="info" htmlFor="startLocation">
                  Pickup From
                </label>
                <br />
                <div className="input-group mb-3">
                  <span
                    className={
                      city ? "input-group-text active" : "input-group-text"
                    }
                    onClick={() => {
                      setCity(!city);
                    }}
                    id="basic-addon1">
                    <img className="address" src={address} alt="address" />{" "}
                    {travel}
                    <IoMdArrowDropdown className="down" />
                    <ul>
                      <li
                        onClick={() => {
                          setTravel("Cairo");
                        }}>
                        Cairo
                      </li>
                      <li
                        onClick={() => {
                          setTravel("Alex");
                        }}>
                        Alex
                      </li>
                    </ul>
                  </span>
                  <input
                    className="form-control"
                    name="startLocation"
                    placeholder="Start Location"
                    required
                    onChange={(e) => {
                      setFrom(e.target.value);
                    }}
                  />
                </div>

                <label className="info" htmlFor="endLocation">
                  Arival To
                </label>
                <br />
                <div className="input-group mb-3">
                  <span
                    className={
                      city2 ? "input-group-text active" : "input-group-text"
                    }
                    onClick={() => {
                      setCity2(!city2);
                    }}
                    id="basic-addon1">
                    <img className="address" src={address} alt="address" />{" "}
                    {destinaton}
                    <IoMdArrowDropdown className="down" />
                    <ul className="two">
                      <li
                        onClick={() => {
                          setDestination("Cairo");
                        }}>
                        Cairo
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Alex");
                        }}>
                        Alex
                      </li>
                      <li
                        onClick={() => {
                          setDestination("El Hamam-North Coast");
                        }}>
                        El Hamam-North Coast
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Marina-North Coast");
                        }}>
                        Marina-North Coast
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Sidi Abdalrahman-North Coast");
                        }}>
                        Sedi Abdalrahman-North Coast
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Marasi-North Coast");
                        }}>
                        Marasi-North Coast
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Al Alamein-North Coast");
                        }}>
                        Al Alamein-North Coast
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Telal-North Coast");
                        }}>
                        Telal-North Coast
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Ghazala-North Coast");
                        }}>
                        Ghazala-North Coast
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Al Dabaa-Noth Coast");
                        }}>
                        Al Dabaa-Noth Coast
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Sidi Hanish-North-Coast");
                        }}>
                        Sidi Hanish-North-Coast
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Ras Al Hikma-North Coast");
                        }}>
                        Ras Al Hikma-North Coast
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Matrouh");
                        }}>
                        Matrouh
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Damanhour");
                        }}>
                        Damanhour
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Kafr El Zayat");
                        }}>
                        Kafr El Zayat
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Kafr El Dawar");
                        }}>
                        Kafr El Dawar
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Kafr El ShEikh");
                        }}>
                        Kafr El ShEikh
                      </li>
                      <li
                        onClick={() => {
                          setDestination("El Mahala");
                        }}>
                        El Mahala
                      </li>
                      <li
                        onClick={() => {
                          setDestination(" El Mansoura");
                        }}>
                        {" "}
                        El Mansoura
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Banha");
                        }}>
                        Banha
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Ismailia");
                        }}>
                        Ismailia
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Suez");
                        }}>
                        Suez
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Menoufia");
                        }}>
                        Menoufia
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Tanta");
                        }}>
                        Tanta
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Zagazig");
                        }}>
                        Zagazig
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Faiyum");
                        }}>
                        Faiyum
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Beni Suef");
                        }}>
                        Beni Suef
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Port Said");
                        }}>
                        Port Said
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Damietta");
                        }}>
                        Damietta
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Ras El Bar");
                        }}>
                        Ras El Bar
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Sokhna Before Porto");
                        }}>
                        Sokhna Before Porto
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Sokhna After Porto");
                        }}>
                        Sokhna After Porto
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Hurghada");
                        }}>
                        Hurghada
                      </li>
                      <li
                        onClick={() => {
                          setDestination("El Gouna");
                        }}>
                        El Gouna
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Sahl Hasheesh");
                        }}>
                        Sahl Hasheesh
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Soma Bay");
                        }}>
                        Soma Bay
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Makadi");
                        }}>
                        Makadi
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Safaga");
                        }}>
                        Safaga
                      </li>
                      <li
                        onClick={() => {
                          setDestination("El Koseir");
                        }}>
                        El Koseir
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Marsa Alam");
                        }}>
                        Marsa Alm
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Ras Sudr Before Matarma");
                        }}>
                        Ras Sudr Before Matarma
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Ras Sudr After Matarma");
                        }}>
                        Ras Sudr After Matarma
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Sharm El-Sheikh");
                        }}>
                        Sharm El-Sheikh
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Dahab");
                        }}>
                        Dahab
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Taba");
                        }}>
                        Taba
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Nuweiba");
                        }}>
                        Nuweiba
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Minya");
                        }}>
                        Minya
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Assiut");
                        }}>
                        Assiut
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Sohag");
                        }}>
                        Sohag
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Qena");
                        }}>
                        Qena
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Luxor");
                        }}>
                        Luxor
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Aswan");
                        }}>
                        Aswan
                      </li>
                      <li
                        onClick={() => {
                          setDestination("8 Hours Inside Cairo");
                        }}>
                        8 Hours Inside Cairo
                      </li>
                      <li
                        onClick={() => {
                          setDestination("12 Hours Inside Cairo");
                        }}>
                        12 Hours Inside Cairo
                      </li>
                    </ul>
                  </span>
                  <input
                    className="form-control"
                    name="endLocation"
                    placeholder="End Location"
                    required
                    onChange={(e) => {
                      setTo(e.target.value);
                    }}
                  />
                </div>
                <label className="info mt-4" htmlFor="packup">
                  Packup Date{" "}
                </label>
                <br />
                <input
                  className="form-control date"
                  name="packup"
                  defaultValue={today}
                  type="date"
                  onChange={(e) => {
                    setGoDate(e.target.value);
                  }}
                />
                <div className="button d-flex justify-content-between">
                  <TripPrice
                    travel={travel}
                    destination={destinaton}
                    type={tripe}
                    price={
                      <Price
                        travel={travel}
                        destination={destinaton}
                        type={tripe}
                      />
                    }
                  />
                  <Detail from={from} to={to} />
                </div>
              </>
            ) : (
              <>
                <label className="info" htmlFor="startLocation">
                  Pickup From
                </label>
                <br />
                <div className="input-group mb-3">
                  <span
                    className={
                      city ? "input-group-text active" : "input-group-text"
                    }
                    onClick={() => {
                      setCity(!city);
                    }}
                    id="basic-addon1">
                    <img className="address" src={address} alt="address" />{" "}
                    {travel}
                    <IoMdArrowDropdown className="down" />
                    <ul>
                      <li
                        onClick={() => {
                          setTravel("Cairo");
                        }}>
                        Cairo
                      </li>
                      <li
                        onClick={() => {
                          setTravel("Alex");
                        }}>
                        Alex
                      </li>
                    </ul>
                  </span>
                  <input
                    className="form-control"
                    name="startLocation"
                    required
                    placeholder="Start Location"
                    onChange={(e) => {
                      setFrom(e.target.value);
                    }}
                  />
                </div>

                <label className="info" htmlFor="endLocation">
                  Arival To
                </label>
                <br />
                <div className="input-group mb-3">
                  <span
                    className={
                      city2 ? "input-group-text active" : "input-group-text"
                    }
                    onClick={() => {
                      setCity2(!city2);
                    }}
                    id="basic-addon1">
                    <img className="address" src={address} alt="address" />{" "}
                    {destinaton}
                    <IoMdArrowDropdown className="down" />
                    <ul className="two">
                      <li
                        onClick={() => {
                          setDestination("Cairo");
                        }}>
                        Cairo
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Alex");
                        }}>
                        Alex
                      </li>
                      <li
                        onClick={() => {
                          setDestination("El Hamam-North Coast");
                        }}>
                        El Hamam-North Coast
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Marina-North Coast");
                        }}>
                        Marina-North Coast
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Sidi Abdalrahman-North Coast");
                        }}>
                        Sedi Abdalrahman-North Coast
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Marasi-North Coast");
                        }}>
                        Marasi-North Coast
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Al Alamein-North Coast");
                        }}>
                        Al Alamein-North Coast
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Telal-North Coast");
                        }}>
                        Telal-North Coast
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Ghazala-North Coast");
                        }}>
                        Ghazala-North Coast
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Al Dabaa-Noth Coast");
                        }}>
                        Al Dabaa-Noth Coast
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Sidi Hanish-North-Coast");
                        }}>
                        Sidi Hanish-North-Coast
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Ras Al Hikma-North Coast");
                        }}>
                        Ras Al Hikma-North Coast
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Matrouh");
                        }}>
                        Matrouh
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Damanhour");
                        }}>
                        Damanhour
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Kafr El Zayat");
                        }}>
                        Kafr El Zayat
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Kafr El Dawar");
                        }}>
                        Kafr El Dawar
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Kafr El ShEikh");
                        }}>
                        Kafr El ShEikh
                      </li>
                      <li
                        onClick={() => {
                          setDestination("El Mahala");
                        }}>
                        El Mahala
                      </li>
                      <li
                        onClick={() => {
                          setDestination(" El Mansoura");
                        }}>
                        {" "}
                        El Mansoura
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Banha");
                        }}>
                        Banha
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Ismailia");
                        }}>
                        Ismailia
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Suez");
                        }}>
                        Suez
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Menoufia");
                        }}>
                        Menoufia
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Tanta");
                        }}>
                        Tanta
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Zagazig");
                        }}>
                        Zagazig
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Faiyum");
                        }}>
                        Faiyum
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Beni Suef");
                        }}>
                        Beni Suef
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Port Said");
                        }}>
                        Port Said
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Damietta");
                        }}>
                        Damietta
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Ras El Bar");
                        }}>
                        Ras El Bar
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Sokhna Before Porto");
                        }}>
                        Sokhna Before Porto
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Sokhna After Porto");
                        }}>
                        Sokhna After Porto
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Hurghada");
                        }}>
                        Hurghada
                      </li>
                      <li
                        onClick={() => {
                          setDestination("El Gouna");
                        }}>
                        El Gouna
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Sahl Hasheesh");
                        }}>
                        Sahl Hasheesh
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Soma Bay");
                        }}>
                        Soma Bay
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Makadi");
                        }}>
                        Makadi
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Safaga");
                        }}>
                        Safaga
                      </li>
                      <li
                        onClick={() => {
                          setDestination("El Koseir");
                        }}>
                        El Koseir
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Marsa Alam");
                        }}>
                        Marsa Alm
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Ras Sudr Before Matarma");
                        }}>
                        Ras Sudr Before Matarma
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Ras Sudr After Matarma");
                        }}>
                        Ras Sudr After Matarma
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Sharm El-Sheikh");
                        }}>
                        Sharm El-Sheikh
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Dahab");
                        }}>
                        Dahab
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Taba");
                        }}>
                        Taba
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Nuweiba");
                        }}>
                        Nuweiba
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Minya");
                        }}>
                        Minya
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Assiut");
                        }}>
                        Assiut
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Sohag");
                        }}>
                        Sohag
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Qena");
                        }}>
                        Qena
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Luxor");
                        }}>
                        Luxor
                      </li>
                      <li
                        onClick={() => {
                          setDestination("Aswan");
                        }}>
                        Aswan
                      </li>
                      <li
                        onClick={() => {
                          setDestination("8 Hours Inside Cairo");
                        }}>
                        8 Hours Inside Cairo
                      </li>
                      <li
                        onClick={() => {
                          setDestination("12 Hours Inside Cairo");
                        }}>
                        12 Hours Inside Cairo
                      </li>
                    </ul>
                  </span>
                  <input
                    className="form-control"
                    required
                    name="endLocation"
                    placeholder="End Location"
                    onChange={(e) => {
                      setTo(e.target.value);
                    }}
                  />
                </div>
                <div className="d-flex justify-content-between">
                  <div className="packup">
                    <label className="info mt-4" htmlFor="packup">
                      Packup Date{" "}
                    </label>
                    <br />
                    <input
                      className="form-control date"
                      name="packup"
                      defaultValue={today}
                      type="date"
                      onChange={(e) => {
                        setGoDate(e.target.value);
                      }}
                    />
                  </div>
                  <div className="return">
                    <label className="info mt-4" htmlFor="return">
                      Return Date{" "}
                    </label>
                    <br />
                    <input
                      className="form-control date"
                      name="return"
                      defaultValue={today}
                      type="date"
                      onChange={(e) => {
                        setBackDate(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="button d-flex justify-content-between">
                  <TripPrice
                    travel={travel}
                    destination={destinaton}
                    type={tripe}
                    price={
                      <Price
                        travel={travel}
                        destination={destinaton}
                        type={tripe}
                      />
                    }
                  />
                  <Detail from={from} to={to} />
                </div>
              </>
            )}
          </form>
        </>
      )}
      {/* <ul>
        {trips.map((trip, index) => (
          <li key={index}>
            {trip.startLocation} to {trip.endLocation} on {new Date(trip.date).toLocaleDateString()} do {trip.type}
             <button onClick={() => handleDelete(trip._id)}>Delete</button>
          </li>
        ))}
      </ul> */}
    </div>
  );
};

export default Test;
